import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';

type SetTabStateParams = { active: boolean };

export class SetTabState extends JsToClientCommand<SetTabStateParams> {
    constructor(params: SetTabStateParams) {
        super(ClientCommands.SET_TAB_STATE, params);
    }
}
